import useApi from "../api";
import type { Folder, Article, SearchResult } from "./types";

export async function fetchFolders(): Promise<Folder[]> {
  const { get } = useApi();
  const { responseBody } = await get("api/freshDesk/folders", {
    isLogoutOnInvalidAuth: true,
  });
  return responseBody || [];
}

export async function fetchFolderArticles(
  folderId: number
): Promise<Article[]> {
  const { get } = useApi();
  const { responseBody } = await get(
    `api/freshDesk/folder/${folderId}/articles`,
    { isLogoutOnInvalidAuth: true }
  );
  return responseBody || [];
}

export async function searchArticles(term: string): Promise<Article[]> {
  const { get } = useApi();
  const { responseBody } = await get("api/freshDesk/search", {
    isLogoutOnInvalidAuth: true,
    params: { term },
  });

  // The search API returns an object with numeric keys, convert to array
  if (responseBody && typeof responseBody === "object") {
    return Object.values(responseBody as SearchResult);
  }
  return [];
}

export async function fetchArticleById(articleId: number): Promise<Article> {
  const { get } = useApi();
  const { responseBody } = await get(`api/freshDesk/article/${articleId}`, {
    isLogoutOnInvalidAuth: true,
  });
  return responseBody;
}

export async function fetchRelatedArticles(
  articleId: number
): Promise<Array<{ id: number; name: string }>> {
  const { get } = useApi();
  const { responseBody } = await get(
    `api/freshDesk/article/${articleId}/related`,
    { isLogoutOnInvalidAuth: true }
  );
  return responseBody || [];
}
